import { useState, useEffect, use } from "react";
import { Link, useNavigate } from "react-router-dom";

import Footer from "../../Common/Footer";
import "./walletstyle.css";

import { makeApiRequest, callApi } from "../../Services/ApiService";

import { getRecords, PostRecords } from "../../Services/ApiCall";
import {
  decryptOtp,
  getFormattedDate,
  getUser,
  getLoginInfo,
} from "../../Services/Helper";
import { setLogindata } from "../../Services/Urls";

import { useContext } from "react";
import { ApiContext } from "../../Context/Context";
import { useSearchParams } from "react-router-dom";
import { useParams } from "react-router-dom";
import EncryptionHelper from "../../Services/Encrypt";
import { TailSpin } from "react-loader-spinner";
import Header from "../../Common/Header";

export default function PaymentConfirmationPage() {
  const navigate = useNavigate();
  const context = useContext(ApiContext);

  if (!context) {
    throw new Error("useApiContext must be used within a ApiContextProvider");
  }

  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    SODBody,
    setSODBody,
  } = context;
  const { txnid } = useParams();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const decryptedTxnId = txnid ? EncryptionHelper.decrypt(txnid) : "";

  const decryptParam = (key, defaultValue = "") => {
    const value = searchParams.get(key);
    if (!value) return defaultValue;

    try {
      return EncryptionHelper.decrypt(value);
    } catch {
      return defaultValue;
    }
  };

  const status = decryptParam("status");
  const error = decryptParam("error");
  const email = decryptParam("email");
  const phone = decryptParam("phone");
  const easepayid = decryptParam("easepayid");
  const firstname = decryptParam("firstname");
  const amount = decryptParam("amount", "0");
  const mode = decryptParam("mode");
  const billToLedgerID = decryptParam("billToLedgerID");

  const orderId = "123";

  console.log({
    txnid,
    status,
    error,
    email,
    phone,
    easepayid,
    firstname,
    amount,
    mode,
    billToLedgerID,
  });

  useEffect(() => {
    TopupWallet();
    window.scrollTo(0, 0);
  }, []);

  const TopupWallet = () => {
    debugger;
    if (status == "success") {
      let Token = getLoginInfo();

      setLogindata(Token);

      let userData = getUser();

      if (Token && userData) {
        const filter = `{UserID: { $in: [${userData?.UserID}] }}`;

        getRecords(437, 1, filter, 1, "", (data) => {
          if (data != null) {
            if (data?.hasErrors === false) {
              console.log("data", data);

              // setwalletData(data?.response?.records[0] || null);

              const walletData = data?.response?.records?.[0] ?? null;
              console.log("walletData", walletData);

              let body = null;

              if (walletData != null) {
                body = [
                  {
                    WalletID: walletData?.WalletID,

                    Balance:
                      parseFloat(walletData?.Balance || "0") +
                      parseFloat(amount || "0"),
                    TotalCredited:
                      parseFloat(walletData?.TotalCredited || "0") +
                      parseFloat(amount || "0"),
                  },
                ];
              } else {
                body = [
                  {
                    User: userData?.User,
                    UserID: userData?.UserID,
                    Balance: parseFloat(amount),
                    TotalCredited: parseFloat(amount),
                    TotalDebited: 0,
                    Status: "Active",
                    StatusID: 1,
                  },
                ];
              }

              PostRecords(437, 1, body, (data) => {
                if (data != null && data?.response?.hasErrors === false) {
                  setLoading(false);
                  //  toast.success(`${"Balance Added Successfully"}`);
                  //  getwalletdetails();
                } else {
                  setLoading(false);
                  //   toast.error(`${data?.response?.errors}`);
                }
              });

              setLoading(false);
            } else {
              setLoading(false);
              console.log("Error in fetching featured properties", data);
            }
          } else {
            setLoading(false);
          }
        });
      }
    }
  };

  return (
    <>
      {/* <Header /> */}
      <div className="paymentconfirmation min-h-screen bg-white">
         <Header />
        <div className="pt-32 pb-20">
          <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="bg-white rounded-2xl shadow-xl p-12">
              <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-check-line text-5xl text-green-600"></i>
              </div>

              {status == "success" && (
                <>
                  {/* <img className="logo-light logos" src="../assets/img/logo.svg" alt="logo" /> */}
                  <h1 className="text-4xl font-bold text-gray-900 mb-4">
                    Order Confirmed!
                  </h1>

                  <p className="text-lg text-gray-600 mb-8">
                    Thank you for your purchase. Your order has been
                    successfully placed.
                  </p>
                </>
              )}

              {status != "success" && (
                <>
                  {/* <img
                className="logo-light logos"
                src="assets/img/logo.svg"
                alt="logo"
              /> */}
                  <h1 className="text-4xl font-bold text-gray-900 mb-4">
                    Order {status}!
                  </h1>
                </>
              )}

              <div className="bg-gray-50 rounded-xl p-6 mb-8">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-gray-600">Order Number</span>
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-gray-900">
                      {decryptedTxnId}
                    </span>
                    <a
                      onClick={() =>
                        navigator.clipboard.writeText(decryptedTxnId)
                      }
                      className="text-amber-600 hover:text-amber-700"
                    >
                      <i class="ri-file-copy-2-line"></i>
                    </a>
                  </div>
                </div>

                <div className="flex items-center justify-between mb-4">
                  <span className="text-gray-600">Total Amount</span>
                  <span className="font-bold text-gray-900">₹{amount}</span>
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Payment Status</span>
                  <span className="inline-flex items-center gap-2 px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-semibold">
                    <i className="ri-check-line"></i>
                    {status}
                  </span>
                </div>
              </div>

              {/* <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 mb-8">
              <div className="flex items-center justify-center gap-3 mb-2">
                <i className="ri-calendar-line text-2xl text-amber-600"></i>
                <h3 className="text-lg font-semibold text-gray-900">
                  Expected Delivery
                </h3>
              </div>
              <p className="text-2xl font-bold text-amber-600">
                {expectedDeliveryDate.toLocaleDateString("en-IN", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
            </div>

            <p className="text-gray-600 mb-8">
              A confirmation email has been sent to your registered email
              address with order details and tracking information.
            </p> */}

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                {/* <Link
                to="/my-orders"
                className="px-8 py-4 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap"
              >
                Track Order
              </Link> */}
                <button
                  onClick={() => navigate("/")}
                  className="px-8 py-4 bg-white border-2 border-gray-300 text-gray-900 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap"
                >
                  <i class="ri-home-3-line"></i>
                  Back to Home
                </button>
              </div>

              {/* <div className="mt-12 pt-8 border-t border-gray-200">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                What happens next?
              </h3>
              <div className="space-y-4 text-left">
                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-amber-600 font-bold">1</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">
                      Order Processing
                    </h4>
                    <p className="text-sm text-gray-600">
                      We are preparing your order for shipment
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-amber-600 font-bold">2</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">
                      Quality Check
                    </h4>
                    <p className="text-sm text-gray-600">
                      Each product is carefully inspected for quality
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-amber-600 font-bold">3</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Shipped</h4>
                    <p className="text-sm text-gray-600">
                      Your order will be dispatched within 24 hours
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-amber-600 font-bold">4</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Delivered</h4>
                    <p className="text-sm text-gray-600">
                      Fresh products delivered to your doorstep
                    </p>
                  </div>
                </div>
              </div>
            </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}

      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <TailSpin color="#00BFFF" height={80} width={80} />
        </div>
      )}
    </>
  );
}
